import Home from "../PortfolioContainer/Home/Home";
import AboutMe from "../PortfolioContainer/AboutMe/AboutMe";
import Service from "../PortfolioContainer/Service/Service";
import Video from "../PortfolioContainer/Video/Video";
import Photoes from "../PortfolioContainer/Photos/Photos";
import ContactMe from "../PortfolioContainer/ContactMe/ContactMe";
import Testimonials from "../PortfolioContainer/Testimonials/Testimonials";
import MantraHeading from "../PortfolioContainer/MantraHeading/MantraHeading";


export const TOTAL_SCREENS = [
  {
    screen_name: "Home",
    component: Home,
  },
  {
    screen_name: "MantraHeading",
    component: MantraHeading,
  },
  {
    screen_name: "AboutMe",
    component: AboutMe,
  },
  {
    screen_name: "Service",
    component: Service,
  },
  {
    screen_name : "Testimonials",
    component : Testimonials
  },
  {
    screen_name: "ContactMe",
    component: ContactMe,
  },
];

export const GET_SCREEN_INDEX = (screen_name) => {
  if (!screen_name) return -1;

  for (let i = 0; i < TOTAL_SCREENS.length; i++) {
    if (TOTAL_SCREENS[i].screen_name === screen_name) return i;
  }

  return -1;
};
